
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcSystemButton as ObcSystemButtonElement} from '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';
 import {SystemState} from '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';
 export type {SystemState} from '@oicl/openbridge-webcomponents/dist/components/system-button/system-button.js';
 

 
 export const ObcSystemButton = createComponent({
   react: React,
   tagName: 'obc-system-button',
   elementClass: ObcSystemButtonElement,
   events: {
     
     onMenuToggle: 'menu-toggle' as EventName<CustomEvent<{open: boolean}>>,
     onSystemStateChange: 'system-state-change' as EventName<CustomEvent<{state: SystemState}>>,
     onMicrophonePanelOpen: 'microphone-panel-open' as EventName<CustomEvent<void>>,
     onVolumePanelOpen: 'volume-panel-open' as EventName<CustomEvent<void>>,
     onSystemIconsPanelOpen: 'system-icons-panel-open' as EventName<CustomEvent<void>>,
   }
  });
 
 